import React from 'react'
import img1 from './images/accomodations1.jpg'
import img2 from './images/accomodations2.jpg'
import img3 from './images/accomodations3.jpg'

const LocationPage = () => (
  <div className="post">
    <h2 className="title">Accomodations</h2>
    <center>
      <span>
        <center>
          <table cellPadding="0" cellSpacing="5">
            <tbody>
              <tr>
                <td>
                  <img src={img1} style={{maxWidth: 386}}/>
                </td>
                <td>
                  <img src={img2} style={{maxWidth: 386}}/>
                </td>
              </tr>
              <tr>
                <td>
                  <img src={img3} style={{maxWidth: 386}}/>
                </td>
              </tr>
            </tbody>
          </table>
        </center>
      </span>
    </center>
    <h2 className="title">Location</h2>
    <center>
      <span>
        <iframe
          width="425"
          height="350"
          frameBorder="0"
          scrolling="no"
          marginHeight="0"
          marginWidth="0"
          src="https://www.google.com/maps?f=d&amp;source=s_d&amp;saddr=Salt+Lake+International+Airport,+Salt+Lake+City,+UT&amp;daddr=holden,+utah&amp;hl=en&amp;geocode=FQRbbgIdj1FT-SEZSFn1JkMfbynp9Ndni_NShzEZSFn1JkMfbw%3BFeOZVAIdTeJO-SlFjraEcaBMhzHQA3sI9M5TQA&amp;aq=t&amp;sll=39.943436,-111.923218&amp;sspn=3.516322,7.13562&amp;mra=ls&amp;ie=UTF8&amp;t=m&amp;ll=39.942655,-111.958795&amp;spn=1.68761,0.62429&amp;output=embed"
        />
        <br />
        <small>
          <a
            href="https://www.google.com/maps?f=d&amp;source=embed&amp;saddr=Salt+Lake+International+Airport,+Salt+Lake+City,+UT&amp;daddr=holden,+utah&amp;hl=en&amp;geocode=FQRbbgIdj1FT-SEZSFn1JkMfbynp9Ndni_NShzEZSFn1JkMfbw%3BFeOZVAIdTeJO-SlFjraEcaBMhzHQA3sI9M5TQA&amp;aq=t&amp;sll=39.943436,-111.923218&amp;sspn=3.516322,7.13562&amp;mra=ls&amp;ie=UTF8&amp;t=m&amp;ll=39.942655,-111.958795&amp;spn=1.68761,0.62429"
            style={{ color: '#0000FF', textAlign: 'left' }}
          >
            View Larger Map
          </a>
        </small>
      </span>
    </center>
  </div>
)

export default LocationPage



// WEBPACK FOOTER //
// ./src/pages/location.js